"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDropdown = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DropdownMixin = require("../../mixins/components/DropdownMixin");
var _Dialog = require("../Dialog/Dialog");
var StyledDropdown = /*#__PURE__*/(0, _styledComponents.default)(_Dialog.Dialog).withConfig({
  displayName: "StyledDropdown",
  componentId: "c11n-8-107-0__sc-1snjbke-0"
})(["", ""], _DropdownMixin.DropdownMixin);
exports.StyledDropdown = StyledDropdown;